export default __webpack_public_path__ + "static/media/vscode.9ba289c0.png";